// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header_2t8p8","headerContainer":"App_headerContainer_35bMx","logo":"App_logo_1ZPlK","nav":"App_nav_N4Y2v","navLink":"App_navLink_1B4wV","footer":"App_footer_20yti"};